import { render, staticRenderFns } from "./cmsDetailContent.vue?vue&type=template&id=ce981be8&scoped=true&"
import script from "./cmsDetailContent.vue?vue&type=script&lang=js&"
export * from "./cmsDetailContent.vue?vue&type=script&lang=js&"
import style0 from "./cmsDetailContent.scss?vue&type=style&index=0&id=ce981be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce981be8",
  null
  
)

export default component.exports